<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{text.Heading}}</h2>
      <!-- クーポン1件分のループ -->
      <div class="mod-general-box" v-for="(coupon, index) in model.CouponList" :key="index">
        <h3 class="coupon-shop" :class="getType(coupon.business_type)">{{getTypeName(coupon.business_type)}}<br><small>{{text.Limit}} : {{getLimitDate(coupon)}}</small></h3>
        <div class="coupon-summary">
          <div class="coupon-image"><img :src="importImageUri(coupon.image_url)" :alt="coupon.title"></div>
          <p class="set-content">{{coupon.content}}</p>
          <p class="link-note"><a href="#" @click.prevent="execAttention(coupon.on_use_notes)">{{text.Attention}}</a></p>
          <p class="btn-use-coupon"><a href="#" class="btn-base btn-sub" @click.prevent="execUseCoupon(coupon)">{{text.Use}}</a></p>
        </div>
      </div>
      <!-- クーポン1件分のループ -->
      <p v-if="model.CouponList.length===0">{{text.Nothing}}</p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOCoupon',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      text: {
        Heading: null,
        Type: {
          Common: null,
          FK: null,
          WFK: null
        },
        Limit: null,
        Attention: null,
        Use: null,
        Nothing: null
      },
      model: {
        CouponList: []
      }
    }
  },
  computed: {
    getCart () {
      return this.$store.getters.cart
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getCouponDetails () {
      return this.$store.getters.couponDetails
    },
    getIsAcceptingMenu () {
      return this.$store.getters.isAcceptingMenu
    }
  },
  methods: {
    /** クーポンを使う */
    execUseCoupon: function (coupon) {
      try {
        // カートの情報を取得する
        const cart = this.getCart

        if (coupon.item_cd !== null && coupon.item_cd !== '' && coupon.item_cd.length > 0) {
          // セット割引クーポン
          const _that = this
          // セットメニュー詳細APIにリクエストして商品情報を取得する
          this.callApi('SetMenuDetail',
            {
              'store_cd': this.getSelectStore.store_cd,
              'setmenu_cd': coupon.item_cd,
              'coupon_cd': coupon.coupon_cd,
              'receive_method': Number(cart.receive_method),
              language: sessionStorage.getItem('lang')
            }
          )
            .then((res) => {
              if (res.data.result) {
                const setmenuDetails = res.data.value.setmenu_details
                let selectItem

                if (_that.isSelectable(setmenuDetails)) {
                  // 構成要素変更可能商品

                  // メイン商品を検索する
                  let mainmenu
                  for (let i = 0; i < setmenuDetails.length; i++) {
                    if (setmenuDetails[i].is_main_menu) {
                      mainmenu = setmenuDetails[i]
                      break
                    }
                  }

                  // クーポン商品を選択商品にセットしてサイドメニュー選択へ遷移する
                  selectItem = {
                    coupon_cd: coupon.coupon_cd,
                    item: {
                      category_cd: coupon.item_cd,
                      category_name: mainmenu.setitem_list[0].item_name,
                      image_url: mainmenu.setitem_list[0].image_url,
                      is_sales: true,
                      is_terminate: true,
                      item_type: 0,
                      price: 0,
                      tax_type: 2,
                      discount_price: coupon.discount_price // クーポン利用の時は割引価格を両方渡すこと
                    },
                    quantity: 1,
                    setmenu: {
                      category_cd: coupon.item_cd,
                      category_name: res.data.value.setmenu_name,
                      image_url: mainmenu.setitem_list[0].image_url,
                      is_sales: true,
                      is_terminate: true,
                      item_type: 2,
                      price: 0,
                      tax_type: 2
                    },
                    setmenu_details: []
                  }
                  _that.$store.dispatch('setSelectItem', selectItem)
                  _that.$router.push({ name: 'SetMenuDetail' })
                } else {
                  // 構成要素変更不可商品

                  // カートに商品を追加する
                  selectItem = {
                    coupon_cd: coupon.coupon_cd,
                    item: {
                      'category_cd': coupon.item_cd,
                      'category_name': res.data.value.setmenu_name,
                      'image_url': null,
                      'is_sales': true,
                      'is_terminate': true,
                      'item_type': 0
                    },
                    quantity: 1,
                    setmenu: {
                      'category_cd': coupon.item_cd,
                      'category_name': res.data.value.setmenu_name,
                      'image_url': null,
                      'is_sales': true,
                      'is_terminate': true,
                      'item_type': 1,
                      'price': 0,
                      'tax_type': 2
                    },
                    setmenu_details: []
                  }
                  cart.item_list.push(selectItem)

                  // カートを更新
                  _that.$store.dispatch('setCart', cart)
                  _that.$router.push({ name: 'Cart' })
                }
              } else {
                _that.errorFromApi(res.data.errorCode, res.data.error)
              }
            })
            .catch((error) => {
              _that.errorFromAxios(error)
            })
        } else {
          // 会計割引クーポン
          cart.accounting_coupon = {
            coupon_cd: coupon.coupon_cd,
            title: coupon.title
          }
          this.$store.dispatch('setCart', cart)
          this.$router.push({ name: 'Cart' })
        }
      } catch (ex) {
        console.error(ex)
        this.errorFromApp(ex)
      }
    },
    /** 注意事項表示 */
    execAttention: function (notes) {
      try {
        window.commonAlert(notes)
      } catch (ex) {
        this.errorFromApp(ex)
      }
    },
    /** 業種毎にclass名を返却する */
    getType: function (type) {
      switch (type) {
        case 1:
          return 'fk'
        case 2:
          return 'wendys'
        default:
          return 'common'
      }
    },
    /** 業種毎の種別名を返却する */
    getTypeName: function (type) {
      switch (type) {
        case 1:
          return this.text.Type.FK
        case 2:
          return this.text.Type.WFK
        default:
          return this.text.Type.Common
      }
    },
    /** 有効期限を返却する */
    getLimitDate: function (coupon) {
      try {
        let from = coupon.limit_date_from.replace(/[-]/g, '.')
        let to = coupon.limit_date_to.replace(/[-]/g, '.')
        return `${from}～${to}`
      } catch (ex) {
        this.errorFromApp(null, ex)
      }
    },
    /** 構成情報変更フラグ */
    isSelectable: function (setmenuDetail) {
      let ret = false // 構成情報変更フラグ

      // サイドメニューの構成情報が2つ以上含まれていれば構成情報を変更可能とする
      setmenuDetail.filter(function (item, index) {
        if (item.setitem_list.length > 1) {
          ret = true
        }
      })

      return ret
    },
    initView: function () {
      this.text.Heading = this.$i18n.t('Coupon.Heading')
      this.text.Type.Common = this.$i18n.t('Coupon.Common')
      this.text.Type.FK = this.$i18n.t('Coupon.FKLimited')
      this.text.Type.WFK = this.$i18n.t('Coupon.WFKLimited')
      this.text.Limit = this.$i18n.t('Coupon.ExpirationDate')
      this.text.Attention = this.$i18n.t('Coupon.Attention')
      this.text.Use = this.$i18n.t('Coupon.Use')
      this.text.Nothing = this.$i18n.t('Coupon.Nothing')
    },
    init: function () {
      let menuType = 0
      if (this.getIsAcceptingMenu.morning) {
        menuType = 1
      } else if (this.getIsAcceptingMenu.grand) {
        menuType = 2
      }
      if (this.getCouponDetails.length > 0) {
        for (let i = 0; i < this.getCouponDetails.length; i++) {
          const coupon = this.getCouponDetails[i]
          // 共通クーポンは時間帯問わずに表示するので、リストに追加する
          if (coupon.menu_type === 0) {
            this.model.CouponList.push(coupon)
            continue
          }
          // メニュー時間帯でないクーポンは非表示にする
          if (coupon.menu_type !== menuType) {
            continue
          }
          this.model.CouponList.push(coupon)
        }
      }
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Coupon.vue